import PropTypes from 'prop-types';

import { Menu, MenuButton, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { format, formatDistanceToNow, formatDistanceStrict, addSeconds } from "date-fns";


const DeviceInfo = ({ device }) => {

  const humanReadableTime = (seconds) => {
    return formatDistanceStrict(new Date(), addSeconds(new Date(), seconds), {
      unit: seconds >= 3600 ? 'hour' : 'minute'
    });
  };

  return (
    <Menu as="div" className="relative inline-block text-right pr-4">
      <div>
        <MenuButton className="inline-flex justify-center gap-x-1.5 rounded-md bg-white px-2 py-1 text-xs font-medium text-cyan-800 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
          {device.model} - {device.connectcode}
          <ChevronDownIcon aria-hidden="true" className="-mr-1 size-4 text-cyan-500" />
        </MenuButton>
      </div>

      <MenuItems
        transition
        className="text-left absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="block px-2 py-2 text-sm text-gray-700" >
          <div className='text-cyan-800 font-semibold'>Device Information:</div>
          <ul role="list" className="divide-y divide-gray-300">
            <li key={device.id} className="py-4">

              <div className='text-gray-400'>Last update:
                <span className='ml-2 text-gray-900'>
                  {formatDistanceToNow(new Date(device.last_seen), { addSuffix: true })}
                </span>
              </div>
              <div className='mb-4 text-gray-400'>Uptime:
                <span className='ml-2 text-gray-900'>{humanReadableTime(device.uptime)}</span>
              </div>

              <div className='text-gray-400'>First connected:
                <span className='ml-2 text-gray-900'>{format(new Date(device.first_seen), 'P')}</span>
              </div>
              <div className='text-gray-400'>Connect code:
                <span className='ml-2 text-gray-900'>{device.connectcode}</span>
              </div>
              <div className='text-gray-400'>Model:
                <span className='ml-2 text-gray-900'>{device.model}</span>
              </div>
              <div className='mb-4 text-gray-400'>Version:
                <span className='ml-2 text-gray-900'>{device.version}</span>
              </div>

              <div className='text-gray-400'>Host:
                <span className='ml-2 text-gray-900'>{device.hostname}</span>
                {/* TODO: remove hostname probably */}
              </div>
            </li>
          </ul>
        </div>
      </MenuItems>
    </Menu>
  )
}



DeviceInfo.propTypes = {
  device: PropTypes.object.isRequired,
}

export default DeviceInfo;